import type { paths } from "@src/packages/openapi/schema";

type FETProcedure =
  paths["/patients/{patientId}/frozen-embryo-transfer-plans/{planId}/procedures"]["get"]["responses"]["200"]["content"]["application/json"]["data"][number];
type FETBetaOrder =
  paths["/patients/{patientId}/frozen-embryo-transfer-procedures/{procedureId}/beta-hcg-orders"]["get"]["responses"]["200"]["content"]["application/json"]["data"][number];

const activeBetaOrderStatuses: FETBetaOrder["status"][] = [
  "ordered",
  "scheduled",
  "collected",
  "completed",
];

type FETWaitProcedure = Pick<
  FETProcedure,
  "status" | "recordStatus" | "sourceKind" | "actualDate"
>;

export function isFETWaitEligible(
  procedure: FETWaitProcedure | null | undefined,
  order: Pick<FETBetaOrder, "status"> | null | undefined,
) {
  if (!procedure || procedure.recordStatus !== "current") return false;

  // Patient confirmation is the available source in this product. Keep the
  // API status patient-reported/awaiting_report for provenance, but do not
  // make the patient wait for a clinic connection that may never exist.
  if (
    procedure.status === "awaiting_report" &&
    procedure.sourceKind === "patient_reported" &&
    procedure.actualDate !== null
  ) {
    return true;
  }

  return (
    procedure.status === "performed" &&
    order !== null &&
    order !== undefined &&
    activeBetaOrderStatuses.includes(order.status)
  );
}

export function getFETBetaOrderDate(
  order:
    | Pick<FETBetaOrder, "collectionWindowStart" | "collectionWindowEnd">
    | null
    | undefined,
): string | null {
  const value =
    order?.collectionWindowEnd ?? order?.collectionWindowStart ?? null;
  if (!value) return null;
  return value.slice(0, 10);
}
